import script from "./MetricBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MetricBox.vue?vue&type=script&setup=true&lang=js"

import "./MetricBox.vue?vue&type=style&index=0&id=366a3c6d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-366a3c6d"]])

export default __exports__